import { InvoiceAlertsController } from "../../controllers";
import { ComponentBase } from "../_ComponentBase";


/**
 * Component that displays alerts for invoices that are in "Payment Started" status.
 * This component shows warnings for each payment channel that has pending payments.
 * @example
 * ```html
 * <salaxy-invoice-alerts
 *   payment-channels="['palkkausManual', 'holvi', 'talenomOnline']"
 *   is-pro="true">
 * </salaxy-invoice-alerts>
 * ```
 */
export class InvoiceAlerts extends ComponentBase {

   /**
    * The following component properties (attributes in HTML) are bound to the Controller.
    * For detailed functionality, refer to [controller](#controller) implementation.
    */
    public bindings = {
      /** Payment channels for OData query. */
      paymentChannels: "<",
      /** Indicates if used in pro. */
      isPro: "<"
    };

    /** Uses the InvoiceAlertsController */
    public controller = InvoiceAlertsController;

    /** The default template for the component. */
    public defaultTemplate = "salaxy-components/invoices/InvoiceAlerts.html";

}
